import axios from '../api/BaseURL'
import authHeader from './auth-header'

class ReportAPI {
  // get collection
  getCollectionReport(data) {
    return axios.post('/report/collection-report', data, {
      headers: authHeader(),
    })
  }

  // get due
  getDueReport(data) {
    return axios.post('/report/due-report', data, {
      headers: authHeader(),
    })
  }

  // get age
  getAgeReport(data) {
    return axios.post('/report/aging-report', data, {
      headers: authHeader(),
    })
  }
  // get account
  getAccountReport(data) {
    return axios.post('/report/customer-account-statement', data, {
      headers: authHeader(),
    })
  }
}
export default new ReportAPI()
